import React from 'react';
import { Box, Typography } from '@mui/material';

export const renderValue = (val) => {
    if (val === null || val === undefined) return null;
    if (typeof val === 'boolean') return val ? 'Oui' : 'Non';
    if (typeof val === 'number') return String(val);
    if (typeof val === 'string') return val;
    if (Array.isArray(val)) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 0.5 }}>
                {val.map((v, i) => (
                    <Typography key={`val-${i}`} variant="body2" sx={{ color: '#475569', display: 'flex', gap: 1 }}>
                        <span style={{ color: '#3b82f6', fontWeight: 700, minWidth: 16 }}>•</span>
                        <span>{typeof v === 'object' ? JSON.stringify(v) : String(v)}</span>
                    </Typography>
                ))}
            </Box>
        );
    }
    return JSON.stringify(val);
};

export const labelMap = {
    question: 'Question',
    answer: 'Réponse attendue',
    expected_answer: 'Réponse attendue',
    reponse: 'Réponse attendue',
    reponse_attendue: 'Réponse attendue',
    criteria: "Critères d'évaluation",
    evaluation: "Critères d'évaluation",
    evaluation_criteria: "Critères d'évaluation",
    criteres_evaluation: "Critères d'évaluation",
    description: 'Description',
    context: 'Contexte',
    contexte: 'Contexte',
    tips: 'Conseils',
    conseil: 'Conseils',
    difficulty: 'Difficulté',
    difficulte: 'Difficulté',
    category: 'Catégorie',
    categorie: 'Catégorie',
    type: 'Type',
    objective: 'Objectif',
    objectif: 'Objectif',
    skills_evaluated: 'Compétences évaluées',
    competences: 'Compétences évaluées',
    title: 'Titre',
    titre: 'Titre',
    note: 'Note',
    score: 'Score',
    follow_up: 'Question de suivi',
    follow_up_questions: 'Questions de suivi',
    points_a_creuser: 'Points à approfondir',
    questions: "Questions d'entretien",
    critere: 'Critère',
    poids: 'Poids',
    echelle: 'Échelle',
};

export const getLabel = (key) =>
    labelMap[key.toLowerCase()] || key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
